export default __webpack_public_path__ + "static/media/icons.b7fe8aea.svg";